/**
 * 相关搜索栏
 * @author liangxin
 * @since 18/07/16
 */
import './concordance.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { getRelWords } from 'api/case';

class Concordance extends Component {
  static propTypes = {
    // 关键字
    keywordId: PropTypes.number,
    // 关键字
    keyword: PropTypes.string,
    // 相关关键字
    relWords: PropTypes.array,
    // 设置关键字
    setKeyword: PropTypes.func,
  };

  constructor(props) {
    super(props);
  }

  // 相关关键词列
  getRelatedwords() {
    const { relWords } = this.props;
    const htmls = [];
    for (const item of relWords) {
      const { keywordId, keyword } = item;
      let link = `/preview/search-${keywordId}.html`;
      htmls.push(
        <li className="item" key={keywordId} data-id={keywordId}>
          <a
            className="link"
            onClick={this.selectRelatedword.bind(this, keywordId, keyword)}
            href={link}
            target="_blank"
            rel="noopener noreferrer">
            {keyword}
          </a>
        </li>
      );
    }
    return htmls;
  }

  // 选择相关关键词搜索
  selectRelatedword = (keywordId, keyword) => {
    if (keywordId) {
      this.props.setKeyword(keyword);
    }
  };

  render() {
    const { relWords } = this.props;
    return (
      <div>
        {relWords.length > 0 ? (
          <div className="concordance-container">
            <div className="concordance-box">
              <h2 className="title">你可能想找&nbsp;:</h2>
              <ul className="concordance-list">{this.getRelatedwords()}</ul>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Concordance;
